import { render, staticRenderFns } from "./InviteGalleryIndex.vue?vue&type=template&id=a2ab32de&"
import script from "./InviteGalleryIndex.vue?vue&type=script&lang=js&"
export * from "./InviteGalleryIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports